import { IfStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AvisosService } from 'src/app/services/avisos.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalAvisoComponent } from 'src/app/templates/modal-aviso/modal-aviso.component';
declare var $: any;

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ModalAvisoComponent]
})
export class NotificationsComponent implements OnInit {

  codAviTipo: string = '0|S'; 
  filtroMural: string = 'N';
  tipos: any[] = [];
  temAceite: boolean = true;

  avisos: any[] = [];
  numPagina: number = 1;
  numAviPagina: number = 10
  temMais: boolean = false;

  itemSel: any;

  constructor(private avisosService: AvisosService, private route: ActivatedRoute) {


   this.route.queryParams.subscribe(params => {

      if(typeof params['codAviTipo'] != 'undefined'){
        this.codAviTipo = params['codAviTipo'] + '|N';
      }else{
        this.codAviTipo = '0|S'; 
      }

      if(typeof params['filtroMural'] != 'undefined'){
        this.filtroMural = params['filtroMural'];
      }else{
        this.filtroMural = 'N';
      }

      this.avisos=[];

      this.listarAvisos();
      this.listarTipos();
   });

    
  }

  ngOnInit() {
  }

  listarTipos(){
   
    this.avisosService
    .ListarTipos(this.filtroMural)
    .subscribe(
      (res: any[]) => {
        this.tipos = res;
      }
    );
    
  }


  listarAvisos(){

    let parts = this.codAviTipo.split('|'); 
    let codAviTipo: number = Number(parts[0]);
    this.temAceite = parts[1] == 'S';

    this.avisosService
        .ListarHistorico(codAviTipo, this.filtroMural, this.numAviPagina, this.numPagina)
        .subscribe(
          (res: any[]) => {

              res.forEach((item) => {
                this.avisos.push(item);
              });

              if(res.length>=this.numAviPagina){
                this.temMais = true;
              }else{
                this.temMais = false;
              }

          }
        )
  }

  onTipoChange(){
    this.avisos = [];
    this.numPagina=1;
    this.listarAvisos();
  }

  carregarMais(){
    this.numPagina++;
    this.listarAvisos();
  }

  openModalAViso(item: any){
    this.itemSel = item;
    $('#modalAvisoNot').modal('show');
  }

  onCloseModalAviso(){
    this.itemSel.DEC_ESCONDER='S'
  }

  

}
